//
// StyleElement.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var StyleElement = {
    GRAPH_DEFAULTS:0,
    GRAPH_DATA_1:1,
    GRAPH_DATA_2:2,
    GRAPH_DATA_3:3,
    GRAPH_DATA_4:4,
    GRAPH_DATA_5:5,
    GRAPH_DATA_6:6,
    GRAPH_DATA_7:7,
    GRAPH_DATA_8:8,
    GRAPH_DATA_9:9,
    GRAPH_DATA_10:10,
    GRAPH_DATA_11:11,
    GRAPH_DATA_12:12,
    GRAPH_DATA_DEFAULT:13,
    GRAPH_DATA_NODE_1:14,
    GRAPH_DATA_NODE_2:15,
    GRAPH_DATA_NODE_3:16,
    GRAPH_DATA_NODE_4:17,
    GRAPH_DATA_NODE_5:18,
    GRAPH_DATA_NODE_6:19,
    GRAPH_DATA_NODE_7:20,
    GRAPH_DATA_NODE_8:21,
    GRAPH_DATA_NODE_9:22,
    GRAPH_DATA_NODE_10:23,
    GRAPH_DATA_NODE_11:24,
    GRAPH_DATA_NODE_12:25,
    GRAPH_DATA_NODE_DEFAULT:26,
    GRAPH_DATA_NODE_TARGET:27,
    GRAPH_KPI_RANGE_1:28,
    GRAPH_KPI_RANGE_2:29,
    GRAPH_KPI_RANGE_3:30,
    GRAPH_KPI_RANGE_4:31,
    GRAPH_KPI_RANGE_5:32,
    GRAPH_KPI_RANGE_DEFAULT:33,
    GRAPH_KPI_OVERFLOW:34,
    GRAPH_KPI_UNDERFLOW:35,
    GRAPH_OUTLIER:36,
    THREE_COLOR_RAMP:37,
    THREE_COLOR_RAMP_1:38,
    THREE_COLOR_RAMP_2:39,
    THREE_COLOR_RAMP_3:40,
    THREE_COLOR_RAMP_4:41,
    THREE_COLOR_RAMP_KPI:42,
    THREE_COLOR_ALT_RAMP:43,
    THREE_COLOR_ALT_RAMP_1:44,
    THREE_COLOR_ALT_RAMP_2:45,
    THREE_COLOR_ALT_RAMP_3:46,
    THREE_COLOR_ALT_RAMP_4:47,
    THREE_COLOR_ALT_RAMP_KPI:48,
    TWO_COLOR_RAMP:49,
    TWO_COLOR_RAMP_1:50,
    TWO_COLOR_RAMP_2:51,
    TWO_COLOR_RAMP_3:52,
    TWO_COLOR_RAMP_4:53,
    TWO_COLOR_RAMP_5:54,
    TWO_COLOR_RAMP_6:55,
    TWO_COLOR_RAMP_7:56,
    TWO_COLOR_RAMP_8:57,
    TWO_COLOR_RAMP_OTHER:58,
    TWO_COLOR_ALT_RAMP:59,
    TWO_COLOR_ALT_RAMP_1:60,
    TWO_COLOR_ALT_RAMP_2:61,
    TWO_COLOR_ALT_RAMP_3:62,
    TWO_COLOR_ALT_RAMP_4:63,
    TWO_COLOR_ALT_RAMP_5:64,
    TWO_COLOR_ALT_RAMP_6:65,
    TWO_COLOR_ALT_RAMP_7:66,
    TWO_COLOR_ALT_RAMP_8:67,
    TWO_COLOR_ALT_RAMP_OTHER:68,
    ICON_NODE_BACKGROUND:69,
    ICON_NODE_END:70,
    ICON_NODE_GATEWAY_EXCLUSIVE:71,
    ICON_NODE_GATEWAY_INCLUSIVE:72,
    ICON_NODE_START:73,
    ICON_NODE_TIMER:74,
    GRAPH_AXIS_LINES:75,
    GRAPH_REFERENCE:76,
    GRAPH_GRID_LINES:77,
    GRAPH_MINOR_GRID_LINES:78,
    GRAPH_OUTLINES:79,
    GRAPH_OUTLINES_PERIMETER:80,
    GRAPH_OUTLINES_UNFILLED:81,
    GRAPH_OUTLINES_NODE:82,
    GRAPH_BORDER_LINES:83,
    GRAPH_TITLE_TEXT:84,
    GRAPH_FOOTNOTE_TEXT:85,
    GRAPH_DATA_TEXT:86,
    GRAPH_KEY_TEXT:87,
    GRAPH_KEY_OUTLINE:88,
    GRAPH_KEY_FRAME_VALUE:89,
    GRAPH_LABEL_TEXT:90,
    GRAPH_LABEL2_TEXT:91,
    GRAPH_VALUE_TEXT:92,
    GRAPH_CALLOUT_LINE:93,
    GRAPH_KPI_RANGE_TEXT:94,
    GRAPH_KPI_VALUE_TEXT:95,
    GRAPH_BACKGROUND:96,
    GRAPH_WALLS:97,
    GRAPH_FLOOR:98,
    GRAPH_LEGEND_BACKGROUND:99,
    GRAPH_HEADER_BACKGROUND:100,
    GRAPH_FIT_LINE:101,
    GRAPH_FIT_LINE_2:102,
    GRAPH_PREDICTION_LINE:103,
    GRAPH_CONFIDENCE:104,
    GRAPH_CONFIDENCE_2:105,
    GRAPH_PREDICTION_LIMIT:106,
    GRAPH_ERROR:107,
    GRAPH_BOX_MEDIAN:108,
    GRAPH_BOX_MEAN:109,
    GRAPH_BOX_WHISKER:110,
    GRAPH_ANNO_LINE:111,
    GRAPH_ANNO_TEXT:112,
    GRAPH_ANNO_SHAPE:113,
    GRAPH_SELECTION:114,
    GRAPH_FOCUS:115,
    GRAPH_FOCUS_BACKGROUND:116,
    GRAPH_MISSING:117,
    GRAPH_CONTROL_LIMITS:118,
    GRAPH_RUN_TEST:119,
    GRAPH_STARS:120,
    GRAPH_CLIPPING:121,
    GRAPH_RANGE_FILL:122,
    GRAPH_DROP_SHADOW:123,
    GRAPH_BOX:124,
    GRAPH_HISTOGRAM:125,
    GRAPH_BAR:126,
    GRAPH_PIE:127,
    GRAPH_INSET_PIE:128,
    GRAPH_BUBBLE:129,
    GRAPH_SCATTER:130,
    GRAPH_HIGHLOW:131,
    GRAPH_HEATMAP:132,
    GRAPH_ICICLE:133,
    GRAPH_WATERFALL:134,
    GRAPH_SCHEDULE:135,
    GRAPH_TIMESERIES:136,
    GRAPH_SERIES:137,
    GRAPH_LINECHART:138,
    GRAPH_BAND:139,
    GRAPH_DECISIONTREE:140,
    GRAPH_LINEAGE:141,
    GRAPH_NETWORK:142,
    GRAPH_PROCESSFLOW:143,
    GRAPH_SANKEY:144,
    GRAPH_ELLIPSE:145,
    GRAPH_CONNECT_LINE:146,
    GRAPH_UNICODE_TEXT:147,
    GRAPH_OVERFLOW:148,
    GRAPH_UNDERFLOW:149,
    GRAPH_OUT_OF_RANGE:150,
    GRAPH_DATA_STYLE_INITIAL:151,
    GRAPH_DATA_STYLE_FINAL:152,
    GRAPH_DATA_STYLE_OTHER:153,
    GRAPH_ROW_COLUMN_AXIS_CELL_FILL:154,
    GRAPH_TIP_TEXT:155,
    GRAPH_TIP_FILL:156,
    GRAPH_MILESTONE:157,
    GRAPH_WEEKEND:158,
    GRAPH_CONTOUR:159,
    GRAPH_BLOCK:160,
    GRAPH_ALT_BLOCK:161,
    GRAPH_BLOCK_HEADER:162,
    GRAPH_CUT_LINE:163,
    GRAPH_TABLE_GRIDLINES:164,
    GRAPH_TABLE_HEADER_FILL:165,
    GRAPH_TABLE_HEADER_TEXT:166,
    GRAPH_TABLE_DATA_FILL:167,
    GRAPH_TABLE_DATA_TEXT:168,
    GRAPH_DIAGRAM_GRID_LINES:169,
    GRAPH_NODE_LINK_DIAGRAM:170,
    GRAPH_NODE:171,
    GRAPH_NODE_TITLE:172,
    GRAPH_NODE_LABEL:173,
    GRAPH_NODE_INPUT_LABEL:174,
    GRAPH_NODE_DETAILS:175,
    GRAPH_NODE_TEXT:176,
    GRAPH_NODE_LINK_LABEL:177,
    GRAPH_NODE_GROUP_OPEN:178,
    GRAPH_NODE_GROUP_CLOSED:179,
    GRAPH_NODE_GROUP_TITLE:180,
    GRAPH_NODE_WINDOW_GROUP_CONTENT_AREA:181,
    GRAPH_LINK:182,
    GRAPH_CROSSOVER_LINK:183,
    GRAPH_HIGHLIGHTED_LINK:184,
    GRAPH_HIGHLIGHTED_NODE:185,
    GRAPH_STATUS_BACKGROUND:186,
    GRAPH_STATUS_CLUSTERED:187,
    GRAPH_STATUS_COMPLETE:188,
    GRAPH_STATUS_ERROR:189,
    GRAPH_STATUS_IMPORTANT:190,
    GRAPH_STATUS_INCOMPLETE:191,
    GRAPH_STATUS_INCOMPLETE_IN_PROGRESS:192,
    GRAPH_STATUS_INFORMATION:193,
    GRAPH_STATUS_LOCKED:194,
    GRAPH_STATUS_MEDIUM_PRIORITY:195,
    GRAPH_STATUS_NEUTRAL:196,
    GRAPH_STATUS_PROGRESS:197,
    GRAPH_STATUS_SCHEDULED:198,
    GRAPH_STATUS_STOPPED:199,
    GRAPH_STATUS_STOPPING:200,
    GRAPH_STATUS_WARNING:201,
    GRAPH_ANIMATED_PROGRESS_INDICATOR:202,
    GRAPH_NOTE_YELLOW:203,
    GRAPH_NOTE_PINK:204,
    GRAPH_NOTE_BLUE:205,
    GRAPH_NOTE_TEXT:206,
    GRAPH_GROUP:207,
    GRAPH_GROUP_BACKGROUND:208,
    GRAPH_GROUP_TITLE:209,
    GRAPH_GROUP_NODE:210,
    GRAPH_LEVEL_GROUP_LABEL:211,
    GRAPH_LEVEL_GROUP_LINE:212,
    GRAPH_LEVEL_LABEL:213,
    GRAPH_SKIN:214,
    GRAPH_OVERVIEW_BACKGROUND:215,
    GRAPH_OVERVIEW_BORDER_LINES:216,
    GRAPH_OVERVIEW_VIEWPORT_BACKGROUND:217,
    GRAPH_OVERVIEW_VIEWPORT_BORDER_LINES:218,
    GRAPH_OVERVIEW_FILTER:219,
    GRAPH_OVERVIEW_AXIS:220,
    GRAPH_OVERVIEW_AXIS_FILTER:221,
    GRAPH_LINEAR_AXIS:222,
    GRAPH_LOG_AXIS:223,
    GRAPH_TIME_AXIS:224,
    GRAPH_DISCRETE_AXIS:225,
    GRAPH_CONTINUOUS_LEGEND:226,
    GRAPH_DISCRETE_LEGEND:227,
    GRAPH_SIZE_LEGEND:228,
    GRAPH_LAYOUT_OVERLAY:229,
    GRAPH_LAYOUT_LATTICE:230,
    GRAPH_LAYOUT_DATA_MATRIX:231,
    GRAPH_CELL_SEPARATOR_LINES:232,
    GRAPH_DATA_MATRIX_BORDER_LINES:233,
    GRAPH_ZOOM_SCROLLBAR_END_HANDLE:234,
    GRAPH_ZOOM_SCROLLBAR_THUMB:235,
    GRAPH:236,
    GRAPH_ANIMATION_CONTROL_PANEL:237,
    GRAPH_GAUGE_INDICATOR:238,
    GRAPH_OVERPLOTTING:239,
    GRAPH_OVERLAY_DATA_INSET:240,
    GRAPH_GEO_ROUTE_MAIN_PATH:241,
    GRAPH_GEO_ROUTE_CENTER_PATH:242,
    GRAPH_GEO_ROUTE_PATH_OUTER_PERIMETER:243,
    GRAPH_GEO_ROUTE_PATH_INNER_PERIMETER:244,
    GRAPH_GEO_ROUTE_PATH_SELECTION:245,
    GRAPH_GEO_ROUTE_PATH_HOVER:246,
    GRAPH_GEO_ROUTE_PATH_OUTER_PERIMETER_INVERSE:247,
    GRAPH_GEO_ROUTE_PATH_FOCUS:248,
    GRAPH_GEO_ROUTE_PATH_FOCUS_PERIMETER:249,
    GRAPH_GEO_ROUTE_POINT:250,
    GRAPH_GEO_ROUTE_POINT_LABEL:251,
    GRAPH_GEO_PIN:252,
    GRAPH_GEO_PIN_LABEL:253,
    GRAPH_GEO_PIN_ICON:254,
    GRAPH_GEO_SEARCH_PIN:255,
    GRAPH_GEO_CENTROID_POINT:256,
    GRAPH_GEO_AREA:257,
    GRAPH_GEO_AREA_OUTER_PERIMETER:258,
    GRAPH_GEO_AREA_INNER_PERIMETER:259,
    GRAPH_GEO_AREA_INNER_PERIMETER_THICK:260,
    GRAPH_GEO_AREA_OUTER_HOVER:261,
    GRAPH_GEO_AREA_OUTER_PERIMETER_INVERSE:262,
    GRAPH_GEO_AREA_SELECTION:263,
    GRAPH_GEO_AREA_OUTER_SELECTION:264,
    GRAPH_GEO_AREA_FOCUS:265,
    GRAPH_GEO_AREA_FOCUS_PERIMETER:266,
    GRAPH_ZONE_A:267,
    GRAPH_ZONE_B:268,
    GRAPH_ZONE_C:269,
    GRAPH_PHASE_BOX:270,
    GRAPH_SLIDER:271,
    GRAPH_MENU:272,
    GRAPH_THIN_LINE:273,
    GRAPH_DATA_STYLE_INCREASING:274,
    GRAPH_DATA_STYLE_DECREASING:275,
    GRAPH_BASEMAP:276,
    GRAPH_MAP_REGION_LAYER:277,
    REPORT:278,
    TITLESTYLE:279,
    PROMPTBAR:280,
    COMBOBOX:281,
    CHECKBOXLIST:282,
    SLIDER:283,
    BUTTONBAR:284,
    RADIOBUTTON:285,
    TEXTINPUT:286,
    HYPERLINK:287,
    HYPERLINKVISITED:288,
    DROPZONE:289,
    HOVER:290,
    SELECTED:291,
    TABLE:292,
    HEADER:293,
    DATA:294,
    BRUSH:295,
    ROW_HEADER:296,
    COLUMN_HEADER:297,
    ROW_HEADER_LABEL:298,
    COLUMN_HEADER_LABEL:299,
    MEASURE_HEADER:300,
    TOTALS:301,
    SUBTOTALS:302,
    TABLE_HEADER:303,
    TABLE_TOTALS:304,
    TABLE_TABLE:305,
    TABLE_DATA:306,
    TABLE_SELECTED:307,
    TABLE_BRUSH:308,
    CROSSTAB_TABLE:309,
    CROSSTAB_DATA:310,
    CROSSTAB_HEADER:311,
    CROSSTAB_TOTALS:312,
    CROSSTAB_SUBTOTALS:313,
    CROSSTAB_SELECTED:314,
    CROSSTAB_BRUSH:315,
    ZOOM_SCROLLBAR:316,
    STACK_NAVIGATION_CONTROL:317,
    STACK_CONTAINER:318,
    REPORT_ELEMENT_CONTAINER:319,
    REPORT_PAGE_PADDING:320,
    CONTAINER:321,
    SCROLLBAR:322,
    TABLE_SCROLLBAR:323,
    CROSSTAB_SCROLLBAR:324,
    TEXT_SCROLLBAR:325,
    TEXTSTYLE:326,
    H1:327,
    H2:328,
    H3:329,
    H4:330,
    H5:331,
    H6:332,
    INVALID:333,
    MATCHES_ALL:334
};
export default StyleElement;
